<template>
  <v-row>
    <v-col :cols="can_select_all ? 8 : 12">
      <v-autocomplete
        v-model="selected_value_input"
        :items="data"
        :item-value="(item) => item[data_id]"
        :item-text="
          (item) =>
            lower_case
              ? objectTranslatorLowerCase(item, data_name)
              : objectTranslator(item, data_name)
        "
        outlined
        dense
        :label="label"
        :disabled="select_search_all_input"
        hide-details
      />
    </v-col>
    <v-col v-if="can_select_all" cols="4">
      <v-checkbox
        v-model="select_search_all_input"
        :label="search_all_label"
        class="mt-1"
        :disabled="disable_select_all"
        hide-details
      ></v-checkbox>
    </v-col>
  </v-row>
</template>

<script>
import {
  objectTranslator,
  objectTranslatorLowerCase,
} from "@/helper/translator";
export default {
  name: "Autocomplete",
  props: {
    lower_case: {
      type: Boolean,
    },
    selected_value: {
      type: String,
    },
    select_searh_all: {
      type: Boolean,
      default: false,
    },
    can_select_all: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
    },
    data_id: {
      type: String,
    },
    data_name: {
      type: String,
    },
    label: {
      type: String,
    },
    search_all_label: {
      type: String,
    },
    disable_select_all: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    selectedInput: null,
    selectAllInput: false,
  }),
  methods: {
    objectTranslator,
    objectTranslatorLowerCase,
  },
  computed: {
    selected_value_input: {
      get() {
        return this.selected_value;
      },
      set(val) {
        this.$emit("update_selected_value", val);
      },
    },
    select_search_all_input: {
      get() {
        return this.select_searh_all;
      },
      set(val) {
        this.$emit("update_select_search_all_value", val);
      },
    },
  },
};
</script>

<style></style>
